const API_BASE_URL = "https://user.vr-icu.com";
//const API_BASE_URL = "http://localhost:5000"; // Test mode

export { API_BASE_URL };
